import { BadInputError } from '../errors/BadInputError';

export const emissionsKinds = [
  'emissions',
  'emissions_location',
  'biogenic_co2',
  'biogenic_co2_location',
  'clean_power_avoided_emissions',
] as const;

export type EmissionsKind = (typeof emissionsKinds)[number];

export type EmissionsKindDefinition = {
  displayName: string;
  description: string;
};

const definitions: Map<EmissionsKind, EmissionsKindDefinition> = new Map();

definitions.set('emissions', {
  displayName: 'Emissions',
  description:
    'Emissions for the activity. For electricity consumption, this represents the market-based allocation method.',
});
definitions.set('emissions_location', {
  displayName: 'Location-based electricity emissions',
  description: 'Location-based emissions for electricity consumption.',
});
definitions.set('biogenic_co2', {
  displayName: 'Biogenic CO2 emissions',
  description:
    'Biogenic CO2 emissions for the activity. For electricity consumption, this represents the market-based allocation method.',
});
definitions.set('biogenic_co2_location', {
  displayName: 'Location-based Biogenic CO2 emissions',
  description:
    'Biogenic CO2 emissions for the activity using the location-based allocation method.',
});
definitions.set('clean_power_avoided_emissions', {
  displayName: 'Clean power avoided emissions',
  description: 'The emissions avoided by using clean power.',
});

/**
 * Gets the definition of an emissions kind, throwing an error if the kind
 * doesn't exist.
 */
export function getEmissionsKindDefinition(
  name: EmissionsKind
): EmissionsKindDefinition {
  const def = definitions.get(name);
  if (!def) {
    throw new BadInputError(`No emissions kind named "${name}"`);
  }
  return def;
}
